import { v4 as uuidv4 } from 'uuid';
import { createComponentStore } from '../../utils/createComponentStore';

const generateOutputPlaceholderKey = () =>
  `external_trigger_${uuidv4().split('-')[0]}`;

const initData = () => ({
  selectedAppNameSlug: '',
  selectedTriggerKey: '',
  configuredProps: {},
  triggerId: '',
  outputPlaceholderKey: generateOutputPlaceholderKey(),
});

const { getStore, defaultStore } = createComponentStore({
  type: 'trigger_from_external_app',
  endpoint: 'trigger_from_external_app',
  registryKey: 'trigger_from_external',
  initData,

  extraState: () => ({
    selectedApp: {},
    selectedTrigger: {},
    appOptions: [],
    appTriggerOptions: [],
    triggersLoading: false,
  }),

  extraActions: (set, get) => ({
    setSelectedApp: (selectedApp) => set((s) => ({
      selectedApp,
      data: { ...s.data, selectedAppNameSlug: selectedApp?.nameSlug || '' },
    })),
    setAppOptions: (appOptions) => set({ appOptions: [...appOptions] }),
    setSelectedTrigger: (selectedTrigger) => set((s) => ({
      selectedTrigger,
      data: {
        ...s.data,
        selectedTriggerKey: typeof selectedTrigger === 'string'
          ? selectedTrigger
          : selectedTrigger?.key || '',
      },
    })),
    setAppTriggerOptions: (opts) => set({ appTriggerOptions: [...opts] }),
    setTriggersLoading: (v) => set({ triggersLoading: v }),
    setConfiguredProps: (configuredProps) => set((s) => ({
      data: { ...s.data, configuredProps: { ...configuredProps } },
    })),
    setTriggerId: (triggerId) => set((s) => ({
      data: { ...s.data, triggerId },
    })),
    setOutputPlaceholderKey: (outputPlaceholderKey) => set((s) => ({
      data: { ...s.data, outputPlaceholderKey },
    })),
  }),
});

export const getTriggerFromExternalStore = getStore;
export default defaultStore;
